import "utility/validation";
import * as yup from "yup";

export default yup.object().shape({
  month: yup.date().required(),
  start: yup.date().required(),
  end: yup.date().required(),
});
